/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListUsersQueryResponse,
  ListUsersQueryParams,
} from '../../types/ListUsers'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listUsers } from '../../clients/listUsers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listUsersQueryKey = (params?: ListUsersQueryParams) =>
  [{ url: '/api/v1/users/' }, ...(params ? [params] : [])] as const

export type ListUsersQueryKey = ReturnType<typeof listUsersQueryKey>

export function listUsersQueryOptions(
  params?: ListUsersQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listUsersQueryKey(params)
  return queryOptions<
    ListUsersQueryResponse,
    ResponseErrorConfig<Error>,
    ListUsersQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listUsers(params, { ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @description List company users with optional filters.
 * Query params:
 * user_type: Filter by group name (multi-value, e.g. ?user_type=Standard&user_type=Admin)
 * is_active: Filter by active/inactive (e.g. ?is_active=true or ?is_active=false)
 * search: Case-insensitive substring match against first_name, last_name, or email.
 * @summary List company users
 * {@link /api/v1/users/}
 */
export function useListUsers<
  TData = ListUsersQueryResponse,
  TQueryData = ListUsersQueryResponse,
  TQueryKey extends QueryKey = ListUsersQueryKey,
>(
  params?: ListUsersQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListUsersQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listUsersQueryKey(params)

  const query = useQuery(
    {
      ...listUsersQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
